/**
 * Handlers do módulo Formulário Simples
 */

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function setupFormularioSimplesHandlers(shadow, config, data, onSubmit) {
    const { cssPrefix } = config;

    const form = shadow.getElementById(`${cssPrefix}-form`);
    const emailInput = shadow.getElementById(`${cssPrefix}-email`);
    const selectInput = shadow.getElementById(`${cssPrefix}-select`);
    const submitButton = shadow.querySelector(`.${cssPrefix}-submit`);
    const emailError = shadow.getElementById(`${cssPrefix}-email-error`);
    const selectError = shadow.getElementById(`${cssPrefix}-select-error`);

    let emailTouched = false;
    let selectTouched = false;
    let formStartFired = false;

    function validateEmail({ onBlur = false } = {}) {
        const shouldShowError = onBlur || emailTouched;
        const value = (emailInput?.value || '').trim();

        if (!value) {
            if (emailError) emailError.textContent = shouldShowError ? data.emailRequiredMessage : '';
            return false;
        }

        if (!EMAIL_REGEX.test(value)) {
            if (emailError) emailError.textContent = data.emailInvalidMessage;
            return false;
        }

        if (emailError) emailError.textContent = '';
        return true;
    }

    function validateSelect({ onBlur = false } = {}) {
        const shouldShowError = onBlur || selectTouched;
        const value = selectInput?.value || '';

        if (!value) {
            if (selectError) selectError.textContent = shouldShowError ? data.selectRequiredMessage : '';
            return false;
        }

        if (selectError) selectError.textContent = '';
        return true;
    }

    function updateSubmitState() {
        const isValid = validateEmail() && validateSelect();
        if (submitButton) {
            submitButton.disabled = !isValid;
        }
        return isValid;
    }

    if (emailInput) {
        emailInput.addEventListener('input', () => {
            emailTouched = true;
            validateEmail();
            updateSubmitState();
        });

        emailInput.addEventListener('blur', () => {
            emailTouched = true;
            validateEmail({ onBlur: true });
            updateSubmitState();
        });
    }

    if (selectInput) {
        selectInput.addEventListener('change', () => {
            selectTouched = true;
            validateSelect();
            updateSubmitState();
        });

        selectInput.addEventListener('blur', () => {
            selectTouched = true;
            validateSelect({ onBlur: true });
            updateSubmitState();
        });
    }

    updateSubmitState();

    // Dispara form_start ao completar (blur com conteúdo) o primeiro campo digitado;
    // campos atômicos (select/checkbox/radio) disparam no próprio "change".
    // Sem offer_id aqui: Formulário Simples é email + seleção de campanha, não
    // está associado a uma oferta (documentId/hash) como os demais handlers.
    function fireFormStart(fieldName) {
        if (formStartFired) return;
        // Só marca como disparado depois de confirmar que o gtag está
        // disponível — senão, um blur antes do GTM carregar perderia o
        // form_start pra sempre nesta sessão (a flag ficava true sem nunca
        // ter enviado o evento).
        if (typeof window.gtag !== 'function') return;
        formStartFired = true;
        window.gtag('event', 'form_start', {
            form_id: 'form_widget_simples',
            form_field: fieldName,
            widget_type: 'formulario-simples',
        });
    }

    shadow.addEventListener('focusout', (e) => {
        const el = e.target;
        if (formStartFired || !el) return;
        const tag = el.tagName;
        if (tag !== 'INPUT' && tag !== 'TEXTAREA') return;
        const type = (el.type || '').toLowerCase();
        if (type === 'checkbox' || type === 'radio') return;
        if (!el.value || !String(el.value).trim()) return;
        fireFormStart(el.name || el.id);
    });

    shadow.addEventListener('change', (e) => {
        const el = e.target;
        if (formStartFired || !el) return;
        const tag = el.tagName;
        const type = (el.type || '').toLowerCase();
        if (tag === 'SELECT' || type === 'checkbox' || type === 'radio') {
            fireFormStart(el.name || el.id);
        }
    });

    form?.addEventListener('submit', async (event) => {
        event.preventDefault();

        emailTouched = true;
        selectTouched = true;

        const isValid = validateEmail({ onBlur: true })
            && validateSelect({ onBlur: true });
        updateSubmitState();
        if (!isValid) return;

        // Dispara evento generated_lead via código (conforme documentação)
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'generate_lead', {
                event_category: 'Lead',
                event_label: 'Oferta Formulário',
                position: 'mzk-widget-' + config.id
            });
        }

        const selectedOption = data.selectOptions.find((option) => option.value === (selectInput?.value || ''));

        const payload = {
            email: (emailInput?.value || '').trim(),
            [data.selectName]: selectInput?.value || '',
            selectedOption
        };

        // Captura a resposta do onSubmit para disparar evento lead
        const result = await onSubmit(payload);

        // Dispara evento lead quando recebe sucesso (capturado no handleSubmit do módulo)
        if (result?.success || result?.ok) {
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'lead', {
                    event_category: 'Lead',
                    event_label: 'Motor v2 Success',
                    widget: config.titleForm || 'Formulário Simples'
                });
            }
        }
    });
}
